var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"social-icons"},_vm._l((this.social),function(social){return _c('a',{attrs:{"href":social.source,"target":social.target}},[_c('b-icon',{attrs:{"icon":social.icon,"size":"is-medium"}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }